import { useState } from 'react';

// NOTE: using local storage in iframe is not supported anymore so make sure u use this in the main app only.
// also, using it like this without a provider creates a scenario were there can be many instances of this useState for the same key.
// best to use a useQuery logic like i created in useCookies.ts
export const useLocalStorage = <T = string>(
  key: string,
  defaultValue: T,
): [T, (value: T) => void] => {
  const [value, setValue] = useState<T>(() => {
    const storedValue = localStorage.getItem(key);
    if (storedValue !== null) {
      try {
        return JSON.parse(storedValue) as T;
      } catch {
        return storedValue as unknown as T;
      }
    } else {
      return defaultValue;
    }
  });
  const setStoredValue = (value: T) => {
    setValue(value);
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      localStorage.setItem(key, String(value));
    }
  };
  return [value, setStoredValue];
};
